export const common = {
  // Navigation
  home: 'Home',
  search: 'Search',
  matches: 'Matches',
  messages: 'Messages',
  successStories: 'Success Stories',
  login: 'Login',
  register: 'Register Free',
  
  // Common Actions
  submit: 'Submit',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  close: 'Close',
  next: 'Next',
  previous: 'Previous',
  
  // Form Fields
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  age: 'Age',
  location: 'Location',
  country: 'Country',
  city: 'City',
  profession: 'Profession',
  education: 'Education',
  religion: 'Religion',
  caste: 'Caste',
  motherTongue: 'Mother Tongue',
  maritalStatus: 'Marital Status',
  
  // Marital Status Options
  neverMarried: 'Never Married',
  divorced: 'Divorced',
  widowed: 'Widowed',
  separated: 'Separated',
  
  // Education Levels
  highSchool: 'High School',
  bachelors: "Bachelor's Degree",
  masters: "Master's Degree",
  doctorate: 'Doctorate',
  diploma: 'Diploma',
  
  // Professions
  engineer: 'Engineer',
  doctor: 'Doctor',
  teacher: 'Teacher',
  businessman: 'Businessman',
  lawyer: 'Lawyer',
  consultant: 'Consultant',
  other: 'Other',
  
  // Common Messages
  loading: 'Loading...',
  error: 'Something went wrong',
  success: 'Success!',
  noResults: 'No results found',
  tryAgain: 'Try again',
  
  // Time
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This week',
  thisMonth: 'This month',
  
  // Premium
  premium: 'Premium',
  upgrade: 'Upgrade',
  choosePlan: 'Choose Plan',
  
  // Footer
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  helpCenter: 'Help Center',
  
  // Global Features
  worldwide: 'Worldwide',
  international: 'International',
  globalCommunity: 'Global Community',
  findLoveAnywhere: 'Find Love Anywhere',
  connectGlobally: 'Connect Globally',

  // Hero Section
  heroTitle: 'Find Your Perfect Life Partner',
  heroSubtitle: 'Join thousands of verified profiles from around the world and discover your life partner with trust and dignity.',
  getStartedFree: 'Get Started Free',
  browseProfiles: 'Browse Profiles',
  verifiedProfiles: 'Verified & Genuine Profiles',
  privacyFocused: 'Privacy-Focused & Secure Platform',
  meaningfulConnections: 'Designed for Meaningful Connections',

  // Features Section
  whyChoose: 'Why Choose Our Platform?',
  whyChooseSubtitle: 'We provide the most trusted and comprehensive matrimony service with advanced features to help you find your perfect life partner',
  verifiedProfilesTitle: 'Verified Profiles',
  verifiedProfilesDesc: 'All profiles are manually verified with ID proof and background checks for your safety and security.',
  advancedSearchTitle: 'Advanced Search',
  advancedSearchDesc: 'Find your perfect match with detailed filters including education, profession, family background, and more.',
  secureMessagingTitle: 'Secure Messaging',
  secureMessagingDesc: 'Connect with potential matches through our secure messaging system with privacy controls.',
  compatibilityMatchingTitle: 'Compatibility Matching',
  compatibilityMatchingDesc: 'Our AI-powered algorithm suggests highly compatible matches based on your preferences and values.',
  support247Title: '24/7 Support',
  support247Desc: 'Get assistance from our dedicated relationship counselors and customer support team anytime.',
  successStoriesTitle: 'Success Stories',
  successStoriesDesc: 'Join thousands of happy couples who found their life partners through our platform.',

  // Profile Page
  myProfile: 'My Profile',
  manageProfile: 'Manage your profile information',
  editProfile: 'Edit Profile',
  saveProfile: 'Save Profile',
  saveChanges: 'Save Changes',
  discardChanges: 'Discard Changes',
  saving: 'Saving...',
  savingChanges: 'Saving Changes...',
  
  // Profile Tabs
  basicInfo: 'Basic Info',
  photos: 'Photos',
  family: 'Family',
  partnerPreferences: 'Partner Preferences',
  
  // Profile Fields
  fullName: 'Full Name',
  phoneNumber: 'Phone Number',
  gender: 'Gender',
  height: 'Height',
  annualIncome: 'Annual Income',
  occupation: 'Occupation',
  aboutMe: 'About Me',
  familyType: 'Family Type',
  familyValues: 'Family Values',
  familyStatus: 'Family Status',
  
  // Profile Placeholders
  enterFullName: 'Enter your full name',
  enterPhone: '+91 1234567890',
  enterAge: 'Enter your age',
  selectGender: 'Select gender',
  enterHeight: 'e.g., 5\'8"',
  selectMaritalStatus: 'Select status',
  enterReligion: 'Enter your religion',
  enterCaste: 'Enter your caste',
  enterMotherTongue: 'Enter your mother tongue',
  enterEducation: 'Enter your education',
  enterOccupation: 'Enter your occupation',
  enterIncome: 'e.g., 5 LPA',
  enterLocation: 'City, State',
  writeAbout: 'Write a brief description about yourself...',
  
  // Gender Options
  male: 'Male',
  female: 'Female',
  otherGender: 'Other',
  
  // Family Options
  nuclearFamily: 'Nuclear Family',
  jointFamily: 'Joint Family',
  traditional: 'Traditional',
  moderate: 'Moderate',
  liberal: 'Liberal',
  middleClass: 'Middle Class',
  upperMiddleClass: 'Upper Middle Class',
  rich: 'Rich',
  affluent: 'Affluent',
  
  // Partner Preferences
  preferredAgeRange: 'Preferred Age Range',
  preferredHeight: 'Preferred Height',
  preferredEducation: 'Preferred Education',
  preferredOccupation: 'Preferred Occupation',
  preferredLocation: 'Preferred Location',
  preferredReligion: 'Preferred Religion',
  
  // Profile Photos
  profilePhotos: 'Profile Photos',
  uploadPhotosDesc: 'Upload at least one photo to complete your profile',
  
  // Welcome Messages
  welcomeTitle: 'Welcome to Shaadipariwar! 🎉',
  completeProfile: 'Complete your profile to start finding your perfect match',
  fillRequiredFields: 'Fill in all required fields and upload at least one photo',
  
  // Subscription Prompt
  upgradeToPremium: 'Upgrade to Premium',
  unlimitedAccess: 'Get unlimited access to all features',
  unlimitedMessaging: 'Unlimited messaging',
  seeWhoViewed: 'See who viewed you',
  advancedFilters: 'Advanced filters',
  prioritySupport: 'Priority support',
  viewPlans: 'View Plans',
  maybeLater: 'Maybe Later',
  
  // Profile Actions
  unsavedChanges: 'You have unsaved changes',
  saveToKeep: 'Save your profile to keep your updates',
  confirmDiscard: 'Are you sure you want to discard your changes?',
  
  // Profile Status Messages
  loadingProfile: 'Loading your profile...',
  unableToLoad: 'Unable to Load Profile',
  sessionExpired: 'Session expired. Please sign in again.',
  tryAgainButton: 'Try Again',
  profileSaved: 'Profile updated successfully!',
  failedToSave: 'Failed to save profile',
  
  // Character Count
  characters: 'characters',
  
  // Required Field
  required: '*',
  
  // Profile Menu
  myMatches: 'My Matches',
  myMessages: 'Messages',
  upgradeToPremiumMenu: 'Upgrade to Premium',
  logout: 'Logout',
  viewProfile: 'View Profile',
  
  // Help
  help: 'Help',
  
  // Select Options
  selectCountry: 'Select Country',
  selectFamilyType: 'Select family type',
  selectFamilyValues: 'Select family values',
  selectFamilyStatus: 'Select family status',
  
  // Marital Status Full
  awaitingDivorce: 'Awaiting Divorce',
  
  // Partner Preference Placeholders
  ageRangePlaceholder: 'e.g., 25-30',
  heightRangePlaceholder: 'e.g., 5\'6" - 6\'0"',
  enterPreferredEducation: 'Enter preferred education',
  enterPreferredOccupation: 'Enter preferred occupation',
  enterPreferredLocation: 'Enter preferred location',
  enterPreferredReligion: 'Enter preferred religion',
  
  privacyNote: 'Privacy Note',
  privacyNoteDesc: 'Your privacy settings will be applied immediately. Users who cannot see your photo will see a placeholder image instead.',
  
  // Profile Photo Visibility
  photoVisibility: 'Photo Visibility',
  privacySettings: 'Privacy Settings',
  controlWhoSees: 'Control who can see your profile photo',
  visibilityOptions: 'Visibility Options',
  showToEveryone: 'Show to Everyone',
  showToEveryoneDesc: 'Your photo is visible to all users',
  showToPremiumOnly: 'Show to Premium Members Only',
  showToPremiumOnlyDesc: 'Only premium members can see your photo',
  showToFreeOnly: 'Show to Free Users Only',
  showToFreeOnlyDesc: 'Only free users can see your photo',
  hideFromEveryone: 'Hide from Everyone',
  hideFromEveryoneDesc: 'Your photo is hidden from all users',
  customVisibility: 'Custom Visibility',
  customVisibilityDesc: 'Choose specific users to hide from',
  hideFromSpecificUsers: 'Hide from Specific Users',
  enterUserIds: 'Enter user IDs (comma separated)',
  userIdsPlaceholder: 'e.g., user123, user456',
  visibilityUpdated: 'Photo visibility settings updated successfully',
  visibilityUpdateFailed: 'Failed to update visibility settings',
  photoHiddenForYou: 'Photo hidden by user',
  premiumOnlyPhoto: 'Upgrade to premium to view',
};
